import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { formatGBP } from "@/lib/utils-cart";
import { Plus } from "lucide-react";
import { toast } from "sonner";

export default function Coupons() {
  const [coupons, setCoupons] = useState([]);
  const [open, setOpen] = useState(false);
  const empty = { code: "", discount_type: "percent", value: 10, min_order: 0 };
  const [form, setForm] = useState(empty);
  const load = () => api.get("/coupons/mine").then((r) => setCoupons(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/coupons", { ...form, value: Number(form.value), min_order: Number(form.min_order) }); toast.success("Coupon created"); setOpen(false); setForm(empty); load(); }
    catch (e) { toast.error("Failed"); }
  };

  return (
    <DashboardLayout title="Coupons" subtitle="Promotional codes for your store."
      actions={<button onClick={() => setOpen(!open)} className="v-btn-primary" data-testid="coupon-add"><Plus size={14} /> New coupon</button>}
    >
      {open && (
        <form onSubmit={create} className="v-card mb-4 grid sm:grid-cols-4 gap-3">
          <input placeholder="CODE" className="v-input uppercase" value={form.code} onChange={(e) => setForm({...form, code: e.target.value})} required data-testid="coupon-code" />
          <select className="v-input" value={form.discount_type} onChange={(e) => setForm({...form, discount_type: e.target.value})} data-testid="coupon-type">
            <option value="percent">% off</option>
            <option value="fixed">$ off</option>
          </select>
          <input type="number" step="0.01" placeholder="Value" className="v-input" value={form.value} onChange={(e) => setForm({...form, value: e.target.value})} required data-testid="coupon-value" />
          <input type="number" step="0.01" placeholder="Min order GBP" className="v-input" value={form.min_order} onChange={(e) => setForm({...form, min_order: e.target.value})} data-testid="coupon-min" />
          <div className="sm:col-span-4 flex gap-2"><button className="v-btn-primary" data-testid="coupon-save">Create coupon</button><button type="button" onClick={() => setOpen(false)} className="v-btn-outline">Cancel</button></div>
        </form>
      )}

      <div className="v-card p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <th className="p-3">Code</th>
              <th className="p-3">Discount</th>
              <th className="p-3 text-right">Min order</th>
              <th className="p-3 text-right">Uses</th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((c) => (
              <tr key={c.id} className="border-b border-border last:border-0">
                <td className="p-3 font-mono font-semibold text-primary">{c.code}</td>
                <td className="p-3">{c.discount_type === "percent" ? `${c.value}% off` : `${formatGBP(c.value)} off`}</td>
                <td className="p-3 text-right font-mono">{formatGBP(c.min_order || 0)}</td>
                <td className="p-3 text-right font-mono">{c.uses || 0}</td>
              </tr>
            ))}
            {coupons.length === 0 && <tr><td colSpan={4} className="p-10 text-center text-muted-foreground">No coupons yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
